export enum UserRolesTypes {
  Admin = 'ADMIN',
  ContentManager = 'CONTENTMANAGER',
  Editor = 'EDITOR',
  Writer = 'WRITER',
  Translator = 'TRANSLATOR',
  Reviewer = 'REVIEWER',
}
